<div class="row pt-zetta">
  <div class="col-7 offset-2 col">
    <h2>{{ heading }}</h2>
    <p class="paragraph pt-giga">{{ paragraph }}</p>
  </div>
</div>
